export default __webpack_public_path__ + "static/media/la.25a36cc1.svg";